import { HttpClient, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { ModalService } from 'src/app/Modals/_modal';
import * as uuid from "uuid"

@Component({
  selector: 'app-notebook-cover-tile',
  templateUrl: './notebook-cover-tile.component.html',
  styleUrls: ['./notebook-cover-tile.component.sass']
})
export class NotebookCoverTileComponent implements OnInit {
  

  constructor(private http:HttpClient,private modalService: ModalService,private toastr:ToastrService) { }

  @Input() notebook:any
  currentId = uuid.v4()
  currentIdimage = uuid.v4()
  currentIdSpinner = "spinner"+uuid.v4()
  currentIdmodal = uuid.v4()
  sub:any
  title:string=""
  notebookId:any
  isVisible: boolean = true;
  isDeleted: boolean = true;
  collaborator:string =""
  isLoading = false

  selectedFiles: any;
  currentFileUpload: any;
  progress:number = 0;
  selectedFile = null;
  changeImage = false;
  filename="no file selected"
  isUploading:boolean = true
  items=[{index:0,name:'Delete'},{index:1,name:'Share'},{index:2,name:'Change Picture'}]
  open:boolean = false
  imagebase64:any ="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"
  @Input() container_type:string = "container"
  @Input() title_type:string = "title"
  dev_api ="http://localhost:443"
  prod_api ="https://server.flowspaceproducitivity.com"
  
  ngOnInit(): void {
      this.title = this.notebook.title
      ////console.log(this.notebook.additionalString)
      this.isLoading=true
      this.http.get(this.prod_api+"/notebooks/photos?id="+this.notebook.additionalString).subscribe(data=>{
        ////console.log(this.imagebase64.text)
        this.isLoading = false
    
      },err=>{
        ////console.log(err)
        this.imagebase64 = err.error.text
        this.isLoading = false
        ////console.log(this.imagebase64)
    
      })

  }

  toggleTrue(){
    this.isVisible = true
  }

  toggleFalse(){
    this.isVisible = false
  }


  updateTitle(){
    this.isLoading = true
    var elem:any = document.getElementById(this.currentId)
    var innerHtml:string = elem.innerText
    ////console.log("**********************************************")
    ////console.log(innerHtml)
    this.notebook.title= innerHtml
   

    this.notebook = this.http.put(this.prod_api+"/notebooks/update_web",this.notebook).subscribe(
        data=>{
          this.notebook = data
          ////console.log(data)
          this.isLoading = false
        }, err=>{
          this.isLoading = false
          ////console.log(err)
        });
  }

  updateNotebook(){
    this.isLoading = true
    this.notebook = this.http.put(this.prod_api+"/notebooks/update_web",this.notebook).subscribe(
      data=>{
        this.notebook = data
        ////console.log(data)
        this.toastr.success("Successfully updated the notebook")
        this.isLoading = false
      }, err=>{
        ////console.log(err)
        this.isLoading = false
      });
  }

  deleteNotebook(){
    this.isLoading = true
    this.http.delete(this.prod_api+"/notebooks/delete?OwnerToken="+ this.notebook.id).subscribe(
      data=>{
        ////console.log(data)
        this.isDeleted = false
        this.isLoading = false
      }, err=>{
        ////console.log(err)
      });
      this.toastr.success("Successfully deleted the notebook")
      this.isLoading = false
  }




  warnUser(){
    alert("please right click this button")
  }

  addCollaborator(){
    this.notebook.collaborators.push(this.collaborator)
    this.collaborator=""
    this.updateNotebook()
  }
  
removeCollab(collab:string){
    this.notebook.collaborators.splice(this.notebook.collaborators.indexOf(this.notebook), 1);;
    this.updateNotebook()
  }

openModal(id: string) {
    this.modalService.open(id);
}

closeModal(id: string) {
    this.modalService.close(id);
}

changedImage(event: { target: { files: null[]; }; }) {
  this.selectedFile = event.target.files[0];
}

upload() {
  this.isUploading = !this.isUploading
  this.progress = 0;
  this.currentFileUpload = this.selectedFiles.item(0);
  this.pushFileToStorage(this.currentFileUpload).subscribe((event: any) => {
    if (event.type === HttpEventType.UploadProgress) {
      this.progress = Math.round(100 * event.loaded / event.total);
    } else if (event instanceof HttpResponse) {
      this.toastr.success('File Successfully Uploaded');
      this.isUploading = !this.isUploading
    }
    this.selectedFiles = undefined;
   }
  );
}

selectFile(event: any) {
  ////console.log("running this code and doing it well")
  this.selectedFiles = event.target.files;
  this.upload()
}


pushFileToStorage(file: File):any{
  const data: FormData = new FormData();
  data.append('title', file.name);
  data.append('image', file);
  data.append('id',this.notebook.id)
  ////console.log(this.notebook)
  const newRequest = new HttpRequest('POST', this.prod_api+'/notebooks/photos', data, {
    reportProgress: true,
    responseType: 'text'
  });
  return this.http.request(newRequest);
}


}
